// 曲线图的数据相关

import { message } from "antd";

import BaseURL from "../../../NetComponents/BaseURL";

// 请求接口获取数据
export const fetchAnaLineData = async ({x_label, y1_label, y2_label, x_data, y1_data, y2_data, time_interval, file_name}) => {
    try {
        const response = await BaseURL.post('api/line/correlation/', {
            x_label: x_label,
            y1_label: y1_label,
            y2_label: y2_label,
            x_data: x_data,
            y1_data: y1_data,
            y2_data: y2_data,
            time_interval: time_interval,
            need_html: 1,
            file_name: file_name,
        })
        const response_data = response.data;
        if (response_data.code !== 200) {
            message.error('出错啦！代码：' + response_data.code);
        }
        return response_data.data;
    } catch (error) {
        message.error('出错啦！' + error);
    };
};
